import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer data-testid="public-footer" className="bg-slate-950 text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo size="lg" variant="dark" />
          <div className="mt-5 text-white font-display font-bold text-xl">
            Lake Cumberland Regional Airport
          </div>
          <p className="mt-4 text-sm text-slate-400 max-w-md leading-relaxed">
            KSME — South-Central Kentucky's general aviation gateway to Lake Cumberland and Somerset.
            Safe, professional, and friendly service for transient pilots, students, and corporate operators.
          </p>
          <p className="mt-6 text-xs font-mono uppercase tracking-widest text-slate-500">
            500 W.O. Newell Drive · Somerset, KY 42503
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs font-mono uppercase tracking-widest text-sky-300 mb-4">Navigate</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/airport" className="hover:text-white">Airport Information</Link></li>
            <li><Link to="/hangars" className="hover:text-white">Hangars</Link></li>
            <li><Link to="/fuel" className="hover:text-white">Fuel Prices</Link></li>
            <li><Link to="/fees" className="hover:text-white">Layout & Fees</Link></li>
            <li><Link to="/gallery" className="hover:text-white">Gallery</Link></li>
            <li><Link to="/flight-schools" className="hover:text-white">Flight Schools</Link></li>
            <li><Link to="/leadership" className="hover:text-white">Board & Staff</Link></li>
            <li><Link to="/attractions" className="hover:text-white">Local Attractions</Link></li>
            <li><Link to="/reports" className="hover:text-white">Annual Reports</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs font-mono uppercase tracking-widest text-sky-300 mb-4">Frequencies</div>
          <dl className="space-y-2 text-sm font-mono-data">
            <div className="flex justify-between"><dt>CTAF</dt><dd>122.800</dd></div>
            <div className="flex justify-between"><dt>AWOS</dt><dd>120.050</dd></div>
            <div className="flex justify-between"><dt>Elevation</dt><dd>927 ft MSL</dd></div>
          </dl>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Lake Cumberland Regional Airport. All rights reserved.</div>
          <div className="font-mono uppercase tracking-widest">KSME · 37.0539°N 84.6155°W</div>
        </div>
      </div>
    </footer>
  );
}
